
      import API from "!../../../../srprsme-react-website/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../srprsme-react-website/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../srprsme-react-website/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../srprsme-react-website/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../srprsme-react-website/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../srprsme-react-website/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../srprsme-react-website/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!../../../../srprsme-react-website/node_modules/resolve-url-loader/index.js!../../../../srprsme-react-website/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].use[3]!./Announcement.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);


if (module.hot) {
  if (!content.locals || module.hot.invalidate) {
    var isEqualLocals = function isEqualLocals(a, b, isNamedExport) {
  if (!a && b || a && !b) {
    return false;
  }
  var p;
  for (p in a) {
    if (isNamedExport && p === "default") {
      // eslint-disable-next-line no-continue
      continue;
    }
    if (a[p] !== b[p]) {
      return false;
    }
  }
  for (p in b) {
    if (isNamedExport && p === "default") {
      // eslint-disable-next-line no-continue
      continue;
    }
    if (!a[p]) {
      return false;
    }
  }
  return true;
};
    var isNamedExport = !content.locals;
    var oldLocals = isNamedExport ? namedExport : content.locals;

    module.hot.accept(
      "!!../../../../srprsme-react-website/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!../../../../srprsme-react-website/node_modules/resolve-url-loader/index.js!../../../../srprsme-react-website/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].use[3]!./Announcement.scss",
      function () {
        if (!isEqualLocals(oldLocals, isNamedExport ? namedExport : content.locals, isNamedExport)) {
                module.hot.invalidate();

                return;
              }

              oldLocals = isNamedExport ? namedExport : content.locals;

              update(content);
      }
    )
  }

  module.hot.dispose(function() {
    update();
  });
}


export * from "!!../../../../srprsme-react-website/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!../../../../srprsme-react-website/node_modules/resolve-url-loader/index.js!../../../../srprsme-react-website/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].use[3]!./Announcement.scss";
       export default content && content.locals ? content.locals : undefined;
